export function generateDefaultInitialMerchantState() {
  return {
    isFetching: false,
    merchantSeoInfo: null,
    merchantBreadcrumbArray: null,
    merchantDetail: null,
    merchantInfo: null,
    merchantSearch: null,
    defaultTab: null
  }
}


function merchantReducer(state = generateDefaultInitialMerchantState(), action) {
  let newState;
  switch (action.type) {
    case 'GET_MERCHANT_SEARCH':
      return {
        ...state,
        isFetching: true
      }
    case 'GET_SUPER_TAB_DATA':
      return {
        ...state,
        isFetching: true
      }
    case 'GET_MERCHANT_INFO_BY_NAME':
      return {
        ...state,
        isFetching: true
      }
    case 'GET_MERCHANT_INFO_BY_POSTFIX':
      return {
        ...state,
        isFetching: true
      }
    case 'GET_MERCHANT_INFO': {
      return {
        ...state,
        isFetching: true
      }
    }
    case 'GET_STATIC_PAGE_INFO': {
      return {
        ...state,
        isFetching: true
      }
    }
    case 'GET_STATIC_PAGE_INFO_FULFILLED':
      newState = {
        ...state,
        staticPage: {...action.payload?.response?.data?.data},
        isFetching: false
      }
      return newState;
    case 'GET_MERCHANT_SEARCH_FULFILLED':
      newState = {
        ...state,
        merchantSearch: {...action.payload?.response?.data?.data},
        isFetching: false
      }
      return newState;
    case 'GET_SUPER_TAB_DATA_FULFILLED':
      newState = {
        ...state,
        superTabData: {...action.payload?.response?.data?.data},
        isFetching: false
      }
      return newState;
    case 'GET_MERCHANT_INFO_BY_NAME_FULFILLED':
      newState = {
        ...state,
        merchantDetail: {...action.payload?.response?.data},
        isFetching: false
      }
      return newState
    case 'GET_MERCHANT_INFO_BY_POSTFIX_FULFILLED':
      newState = {
        ...state,
        merchantDetail: {...action.payload?.response?.data},
        isFetching: false
      }
      return newState
    case 'GET_MERCHANT_INFO_FULFILLED': {
      newState = {
        ...state,
        merchantDetail: {...action.payload?.response?.data?.data},
        isFetching: false,
      };
      return newState
    }
    case 'SET_MERCHANT_DEFAULT_TAB': {
      const defaultTab = action.payload;

      newState = {
        ...state,
        defaultTab,
      };

      return newState;
    }
    default:
      return state
  }
}

export default merchantReducer
